import React, { Component } from 'react'

import lang from '@/lang'
import styles from './address-form-modal.css'
import { ModalBig } from '@/modules/base/components/modal/index'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import AddressForm from '@/modules/base/components/forms/address-form/address-form'
import { ButtonIconSquare, CancelButton } from '@/modules/base/components/buttons/index'
import { customerTypes } from '@/modules/base/util/constants'

import { Portal } from '@mui/material'

const { COMPANY } = customerTypes

class AddressFormModal extends Component {
  constructor(props) {
    super(props)

    const { address } = props
    this.state = {
      address,
    }

    this.form = null
    this.onFinishClicked = this.onFinishClicked.bind(this)
    this.onDataChanged = this.onDataChanged.bind(this)
  }

  onFinishClicked() {
    const { address } = this.state
    const { onFinish } = this.props
    onFinish && onFinish(address)
  }

  onDataChanged(address) {
    this.setState({ address })
  }

  renderActions() {
    const { onAbort } = this.props
    const { address } = this.state

    const submitButtonDisabled = !address
      ? true
      : address.kind === COMPANY
        ? !address.companyName
        : !address.lastName

    return [
      <CancelButton
        key='cancelBtn'
        customClass={styles.actionButton}
        label={lang.cancelButtonLabel}
        onClick={onAbort} />,
      <ButtonIconSquare
        key='submitBtn'
        customClass={styles.actionButton}
        type='submit'
        icon={CheckRoundedIcon}
        disabled={submitButtonDisabled}
        onClick={this.onFinishClicked}
        label={lang.finishButtonLabel} />,
    ]
  }

  render() {
    const { address } = this.state
    const { store, onAbort } = this.props

    const title = address ? lang.customerAddressFormModalEdit : lang.customerAddressFormModalCreate
    const actions = this.renderActions()

    return (
      <Portal>
        <ModalBig
          open={true}
          title={title}
          actions={actions}
          onClose={onAbort}>
          <AddressForm
            ref={(form) => (this.form = form)}
            store={store}
            data={address}
            onDataChanged={this.onDataChanged} />
        </ModalBig>
      </Portal>

    )
  }
}

export default AddressFormModal
